export const userApi = "userSerial";
export const tokenApi = "0febaed7a8fe0951fefd618b176e34d483082e12";

export const BAD_REQUEST_ERRORS =  ["INACTIVE", "NO_CONTENT", "ALL_ACTIVATIONS"];

export const range = (start: any, end: any) => {
    var ans = [];
    for (let i = start; i <= end; i++) {
      ans.push(i);
    }
    return ans;
};

export const years = range(1920, new Date().getFullYear() + 1, 1);

//export const API_DOMAIN = "https://educationfortheworld.org/virtual";
//export const API_DOMAIN = "https://ingles-24siete.com/virtual";
//export const API_DOMAIN = "https://capacitamos.com/online";
//export const API_DOMAIN = "https://enlinea.net.co/cursos";
export const API_DOMAIN = "https://interactivavirtual.com/online";
//export const API_DOMAIN = "https://tuscursosenlinea.com";
//export const API_DOMAIN = "https://interactivas.co/virtual";

export const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Novimbre',
  'Diciembre',
];


export const baseName = "/online";